(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("moe2player", [], factory);
	else if(typeof exports === 'object')
		exports["moe2player"] = factory();
	else
		root["moe2player"] = factory();
})(window, function() {
return 